import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./TopServiceHeader.module.css";
import serviceBG from "../../assets/images/ServiceBG.png";

const TopServiceHeader: React.FC = () => {
  const location = useLocation();
  const { service, stylist, profileImage, from } = location.state || {};


  const imageSrc = profileImage || "/assets/images/freeface.jpg";


  const backLink = from === "times" ? "/times" : "/main";

  return (
    <div className={styles.headerContainer}>
      <div className={styles.backgroundImage}>
        <img
          src={serviceBG}
          alt="Service Background"
          className={styles.background}
        />
        <div className={styles.tint}></div>
      </div>

      <Link to={backLink} className={styles.backButton}>
        <div className={styles.vector}></div>
      </Link>

      <div className={styles.infoContainer}>
        <div className={styles.profileImageContainer}>
          <img
            src={imageSrc}
            alt="Stylist Profile"
            className={styles.profileImage}
          />
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.serviceTitle}>{service || "نامشخص"}</h1>
          <p className={styles.stylistName}>{stylist || "نامشخص"}</p>
        </div>
      </div>
    </div>
  );
};

export default TopServiceHeader;
